/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../../config/api-config';
import {AdnApiClientService} from './adn-api-client.service';

@Injectable({providedIn: 'root'})
export class ProductFeedApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  getFacets(): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['productfeed', 'facets']),
      params: {format: 'json', concise: true}
    });
  }

  search(params: Record<string, any>): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri('productfeed'),
      params: {...params, format: 'json', concise: true}
    });
  }

  list(params: Record<string, any>): Observable<any> {
    return this.search({
      searchString: params.filterByLike || '',
      pageSize: params.pageSize,
      page: params.page,
      colour: params.colour || null,
      brand: params.brand || null,
      gender: params.gender || null,
      merchant: params.merchant || null
    });
  }

  get(id: string, merchantId: string): Observable<any> {
    return this.client.request({
      method: 'GET',
      url: this.apiConfig.getVersionedUri(['productfeed', 'products', id]),
      params: {merchantId}
    });
  }
}
